import { render, staticRenderFns } from "./Ptt.vue?vue&type=template&id=618b98f0&"
import script from "./Ptt.vue?vue&type=script&lang=js&"
export * from "./Ptt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports